import React from 'react';
import { Shield, Lock, AlertTriangle } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-gray-900 py-20 sm:py-32" data-id="element-116">
      <div className="absolute inset-0 z-0 opacity-20" data-id="element-117">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#dc2626,#ef4444)] opacity-20" data-id="element-118"></div>
        {/* Abstract pattern */}
        <div className="absolute inset-y-0 right-0 w-1/2 bg-gradient-to-l from-red-500/10 to-transparent" data-id="element-119"></div>
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')] bg-no-repeat bg-cover opacity-10" data-id="element-120"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center" data-id="element-121">
        <div className="lg:w-1/2 lg:pr-12 mb-10 lg:mb-0" data-id="element-122">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-123">
            Secure Your <span className="text-red-500" data-id="element-124">Digital Assets</span>{' '}
            With Expert Pentesting
          </h1>
          <p className="mt-6 text-xl text-gray-300" data-id="element-125">
            Identify vulnerabilities before hackers do. Our elite team of
            ethical hackers provides comprehensive penetration testing services
            to protect your business.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-126">
            <button className="bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded-md font-medium transition-colors" data-id="element-127">
              Request a Consultation
            </button>
            <button className="bg-transparent border border-gray-600 hover:border-red-500 text-white py-3 px-6 rounded-md font-medium transition-colors" data-id="element-128">
              Learn More
            </button>
          </div>
        </div>
        <div className="lg:w-1/2 flex justify-center" data-id="element-129">
          <div className="relative w-full max-w-md" data-id="element-130">
            <div className="absolute -top-6 -left-6 w-72 h-72 bg-red-500/10 rounded-full blur-3xl" data-id="element-131"></div>
            <div className="absolute -bottom-6 -right-6 w-72 h-72 bg-red-700/10 rounded-full blur-3xl" data-id="element-132"></div>
            <div className="relative bg-gray-800 border border-gray-700 p-8 rounded-xl shadow-2xl" data-id="element-133">
              <div className="flex justify-between mb-6" data-id="element-134">
                <Shield className="h-12 w-12 text-red-500" data-id="element-135" />
                <div className="flex space-x-2" data-id="element-136">
                  <div className="h-3 w-3 rounded-full bg-red-500" data-id="element-137"></div>
                  <div className="h-3 w-3 rounded-full bg-yellow-500" data-id="element-138"></div>
                  <div className="h-3 w-3 rounded-full bg-green-500" data-id="element-139"></div>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4" data-id="element-140">
                Security Assessment
              </h3>
              <div className="space-y-4" data-id="element-141">
                <div className="flex items-center" data-id="element-142">
                  <div className="flex-shrink-0" data-id="element-143">
                    <Lock className="h-5 w-5 text-green-500" data-id="element-144" />
                  </div>
                  <div className="ml-3" data-id="element-145">
                    <p className="text-sm text-gray-300" data-id="element-146">
                      Network Security:{' '}
                      <span className="text-green-500" data-id="element-147">Protected</span>
                    </p>
                  </div>
                </div>
                <div className="flex items-center" data-id="element-148">
                  <div className="flex-shrink-0" data-id="element-149">
                    <AlertTriangle className="h-5 w-5 text-yellow-500" data-id="element-150" />
                  </div>
                  <div className="ml-3" data-id="element-151">
                    <p className="text-sm text-gray-300" data-id="element-152">
                      Web Application:{' '}
                      <span className="text-yellow-500" data-id="element-153">Moderate Risk</span>
                    </p>
                  </div>
                </div>
                <div className="flex items-center" data-id="element-154">
                  <div className="flex-shrink-0" data-id="element-155">
                    <AlertTriangle className="h-5 w-5 text-red-500" data-id="element-156" />
                  </div>
                  <div className="ml-3" data-id="element-157">
                    <p className="text-sm text-gray-300" data-id="element-158">
                      API Security:{' '}
                      <span className="text-red-500" data-id="element-159">Critical Issues</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-6 pt-6 border-t border-gray-700" data-id="element-160">
                <div className="flex items-center justify-between" data-id="element-161">
                  <span className="text-sm text-gray-400" data-id="element-162">
                    Overall Security Score
                  </span>
                  <span className="text-sm font-medium text-yellow-500" data-id="element-163">
                    72/100
                  </span>
                </div>
                <div className="mt-2 w-full bg-gray-700 rounded-full h-2" data-id="element-164">
                  <div className="bg-gradient-to-r from-red-500 via-yellow-500 to-green-500 h-2 rounded-full" style={{
                  width: '72%'
                }} data-id="element-165"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}